import React from "react";
import { useAppSelector } from "../../../hooks/customReduxHooks";
import { useHandlerCDNMultimedia } from "../../../hooks/useHandlerCDNMultimedia";
import { MetodosDePagoArticle, TextArticle } from "./MetodoDePagoStyled";
export var MetodoDePago = function (_a) {
    var metodoDePago = _a.metodoDePago;
    var getCDNMultimedia = useHandlerCDNMultimedia().getCDNMultimedia;
    var settings = useAppSelector(function (state) { var _a, _b; return (_b = (_a = state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData) === null || _b === void 0 ? void 0 : _b.configuraciones; });
    var paymentCardImage = getCDNMultimedia({
        path: metodoDePago.imagen,
        settings: settings,
    });
    return (React.createElement(MetodosDePagoArticle, { key: metodoDePago.pmed_id },
        React.createElement("img", { src: paymentCardImage, alt: metodoDePago.pmed_nombre }),
        React.createElement("div", null,
            React.createElement(TextArticle, null, metodoDePago.popc_cant_cuotas
                ? metodoDePago.popc_descripcion
                : "Debito Online"))));
};
